import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import getThemes, { ThemesKeys } from '../shared/themeShared';

const style = createMultiStyleConfigHelpers(radioAnatomy.keys);

const baseStyle = (theme: ThemesKeys) =>
  style.definePartsStyle({
    container: {
      mr: 3,
    },
    control: {
      boxSizing: 'border-box',
      border: 0,
      bg: 'white',
      boxShadow: `0 0 0 5px white, 0 0 0 6px ${
        getThemes(theme).colors.palette.stroke.primary[80]
      }`,
      m: 1.5,
      _checked: {
        color: getThemes(theme).colors.palette.stroke.primary[50],
        boxShadow: `0 0 0 4px white, 0 0 0 6px ${
          getThemes(theme).colors.palette.stroke.primary[50]
        }`,
        bg: getThemes(theme).colors.palette.surface.primary[50],
        borderColor: getThemes(theme).colors.palette.stroke.primary[50],
        _hover: {
          bg: getThemes(theme).colors.palette.surface.primary[50],
        },
        ':before': {
          bg: getThemes(theme).colors.palette.surface.primary[50],
        },
      },
      '&[data-invalid]': {
        boxShadow: `0 0 0 5px white, 0 0 0 6px ${
          getThemes(theme).colors.palette.errors[50]
        }`,
        _checked: {
          boxShadow: `0 0 0 4px white, 0 0 0 6px ${
            getThemes(theme).colors.palette.errors[50]
          }`,
          bg: getThemes(theme).colors.palette.errors[50],
          ':before': {
            bg: getThemes(theme).colors.palette.errors[50],
          },
        },
      },
    },
    label: {
      height: 'auto',
      lineHeight: 'normal',
    },
  });

const sm = () =>
  style.definePartsStyle({
    control: {
      maxW: 1.5,
      maxH: 1.5,
    },
  });

const md = () =>
  style.definePartsStyle({
    control: {
      maxW: 2.5,
      maxH: 2.5,
      borderRadius: '50%',
    },
  });

const lg = () =>
  style.definePartsStyle({
    control: {
      w: 3.5,
      h: 3.5,
      borderRadius: '50%',
    },
  });

const xl = () =>
  style.definePartsStyle({
    control: {
      w: 4.5,
      h: 4.5,
      borderRadius: '50%',
    },
    label: {
      fontSize: 'xl',
    },
  });

export const radioTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
    sizes: {
      sm: sm(),
      md: md(),
      lg: lg(),
      xl: xl(),
    },
  });

export default (theme: ThemesKeys) => radioTheme(theme);
